export type PendingApprovalLabel = {
  label: string;
  color: "success.main" | "warning.main";
};

export function getPendingApprovalLabel(
  daysPending?: number,
): PendingApprovalLabel | null {
  if (daysPending == null || daysPending < 0) {
    return null;
  }

  if (daysPending === 0) {
    return { label: "Today", color: "success.main" };
  }

  if (daysPending === 1) {
    return { label: "Yesterday", color: "success.main" };
  }

  return {
    label: `${daysPending} days pending`,
    color: "warning.main",
  };
}
